var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46189 0.399182C9.74072 0.14359 10.1189 0 10.5132 0C10.7085 0 10.9018 0.0352523 11.0822 0.103744C11.2626 0.172236 11.4265 0.272626 11.5645 0.399182C11.7026 0.525738 11.8121 0.675982 11.8868 0.841336C11.9615 1.00669 12 1.18392 12 1.36289C12 1.54187 11.9615 1.7191 11.8868 1.88445C11.8121 2.0498 11.7026 2.20005 11.5645 2.3266L3.09322 10.092C2.90335 10.266 2.67153 10.3878 2.42046 10.4453L2.21338 10.4928C1.21169 10.7223 0.327082 9.8007 0.597477 8.80925C0.665031 8.56155 0.801318 8.33804 0.990579 8.16455L9.46189 0.399182Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7547cbfb12add1fb705ad9e8da7b4fbc.svg";
export { ForwardRef as ReactComponent };